import config from '../../config'

import { IGetPutRequest } from '../../interfaces'

const getUpdateInspectionMutationRequest: IGetPutRequest = params => {
  const { airportId } = params

  return {
    method: 'put',
    url: `${config.baseUrl}/${airportId}/Inspections`,
  }
}

export default getUpdateInspectionMutationRequest
